import apiApp from "./index";
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
const token = localStorage.getItem("UserjwtToken");
const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

const RatesApi = {
    // add rates for a tenant
    AddRateForTenant: (data) => {
        const headers = {
            Authorization: `Bearer ${token}`,
            "x-Authorization": decodedToken?.tenantApiKey || "",
            "Content-Type": "application/json",
        };

        return new Promise((resolve, reject) => {
            apiApp
                .post(`/tenant-rates`, data, { headers })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error.response?.data || error.message));
        });
    },

    // renew subscription
    RenewSubscription: (tenantsID, data) => {
        const headers = {
            Authorization: `Bearer ${token}`,
            "x-Authorization": decodedToken?.tenantApiKey || "",
            "Content-Type": "application/json",
        };

        return new Promise((resolve, reject) => {
            apiApp
                .patch(`/tenant/${tenantsID}/billing`, data, { headers })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error.response?.data || error.message));
        });
    },

    // update tenant rate
    UpdateTenantRate: (tenantID, data) => {
        const headers = {
            Authorization: `Bearer ${token}`,
            "x-Authorization": decodedToken?.tenantApiKey || "",
            "Content-Type": "application/json",
        };

        return new Promise((resolve, reject) => {
            apiApp
                .put(`/tenant-rates/${tenantID}`, data, { headers })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error.response?.data || error.message));
        });
    },

    GetActiveTenantRate: (tenantID) => {
        const headers = {
            Authorization: `Bearer ${token}`,
            "x-Authorization": decodedToken?.tenantApiKey || "",
            "Content-Type": "application/json",
        };

        return new Promise((resolve, reject) => {
            apiApp
                .get(`/tenant-rates/tenant/${tenantID}/active`, { headers })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error.response?.data || error.message));
        });
    },

    GetTenantRatesByTenantID: (tenantID) => {
        const headers = {
            Authorization: `Bearer ${token}`,
            "x-Authorization": decodedToken?.tenantApiKey || "",
            "Content-Type": "application/json",
        };

        return new Promise((resolve, reject) => {
            apiApp
                .get(`/tenant-rates/tenant/${tenantID}`, { headers })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error.response?.data || error.message));
        });
    },
}

export default RatesApi;